module.exports = __webpack_public_path__ + "static/media/icon_add-sm.6a1d45cc.svg";